var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import classNames from "classnames";
import IconContainer from "./IconContainer";
const MenuSecondaryIcon = (_a) => {
    var { className, size, title } = _a, props = __rest(_a, ["className", "size", "title"]);
    return (React.createElement(IconContainer, Object.assign({ className: classNames("gerudo-icon-menu-secondary", size, className) }, props),
        React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 80 71.024", role: "img", "aria-label": title },
            React.createElement("title", null, title),
            React.createElement("path", { fill: "currentColor", d: "M0 0h80v16.346H0zM0 27.34h43.481v16.344H0zM0 54.678h61.999v16.346H0z", role: "presentation" }))));
};
MenuSecondaryIcon.defaultProps = {
    title: "Menu secondary",
};
export { MenuSecondaryIcon };
export default MenuSecondaryIcon;
//# sourceMappingURL=MenuSecondary.js.map